import React from 'react'
import GoBackBtn from './GoBackBtn';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';


const KpiReport = () => {
    return (
        <div className='py-6'>
            <div className='px-4'>
                <GoBackBtn />
            </div>
            <div>
                <div className='mt-8 rounded-lg'> 
                    <Table>
                        <Thead className='gradient-bg text-sm'>
                            <Tr>
                                <Th>Content Size</Th>
                                <Th>Approval Status</Th>
                                <Th>No of Screens</Th>
                                <Th>Play Duration</Th>
                                <Th>Formats avl</Th>
                                <Th>Venue Type</Th>
                                <Th>Price</Th>
                            </Tr>
                        </Thead>
                        <Tbody className='text-[13px]'>
                            {
                                [...Array(3).keys()].map((item) => (
                                    <Tr key={item} >
                                        <Td>1920 x 1080px</Td>
                                        <Td>No Content Assigned</Td>
                                        <Td>18336</Td>
                                        <Td>16 sec</Td>
                                        <Td>Image/Video</Td>
                                        <Td>Dr Office & 26 more </Td>
                                        <Td className='text-primary cursor-pointer'>200INR</Td>
                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                    <div className='flex items-center gap-4 justify-between text-lg py-8 px-4'>
                        <div>Total Price</div>
                        <div className='text-primary'>800INR</div>
                    </div>
                    <div className='py-4 text-center'>
                        <button className="btn-primary py-1.5 w-[150px]">
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default KpiReport;